module.exports = __webpack_public_path__ + "static/media/thum1.879a3fdf.jpg";